//export const API_URL = 'http://localhost:51324';
//export const API_URL = 'https://dsposbackend.dockyardsoftware.com';
export const API_URL = 'https://bpos.dockyardsoftware.com';